import { Link, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/pending-approval")({
  component: PendingApproval,
});

function PendingApproval() {
  return (
    <main className="flex-1 flex flex-col items-center justify-center gap-4 px-8 py-16 text-center max-w-md mx-auto">
      <h1 className="text-2xl font-semibold tracking-tight">
        Waiting for approval
      </h1>
      <p className="text-sm text-muted-foreground">
        Your account has been created. We&apos;re reviewing new sign-ups
        manually before enabling the dashboard and API. You&apos;ll get access
        once approved — try signing in again later.
      </p>
      <Link
        to="/sign-out"
        className="text-sm text-muted-foreground hover:text-foreground underline"
      >
        Sign out
      </Link>
    </main>
  );
}
